import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleOff = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	fill: "none",
	viewBox: "0 0 16 17",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8.5,
		r: 6.5,
		fill: "#D9D9D9",
		stroke: "#D9D9D9"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M4 8.5H12"
	})]
});
const ForwardRef = forwardRef(SvgCheckCircleOff);
export default ForwardRef;
